export default __webpack_public_path__ + "static/media/thetan-arena.7096a068.png";